export default "__VITE_ASSET__0aKB7XRe__"